import { useSubmitPmfSurvey as _useSubmitPmfSurvey } from '@griply/hooks';
import { useUpdateUserMutation } from 'shared/hooks/queries/use-update-user-mutation';
import { useSetUserProperties } from 'shared/hooks/use-set-user-properties';
import { useTrackEvents } from 'shared/hooks/use-track-events';
import { useUser } from 'shared/hooks/use-user';

export const useSubmitPmfSurvey = () => {
  const user = useUser();
  const track = useTrackEvents();
  const setUserProperties = useSetUserProperties();
  const { mutate: updateUser } = useUpdateUserMutation();

  return _useSubmitPmfSurvey({ user, track, setUserProperties, updateUser });
};
